import { cn } from 'lib/helpers/utility';

import Footer from '../Footer/Footer';
import Header from '../Header/Header';

const StepperContent = ({
  isAdmin,
  isNarrowScreen,
  isEnteringFromIntro,
  mainContentRef,
  wizardState,
  practice,
  headerProps,
  footerProps,
  stepProps
}) => {
  const {
    headerButtonProps,
    headerOptions,
    headerInfoTooltip,
    setHeaderButtonProps,
    setHeaderInfoTooltip,
    progressValue,
    shouldAnimateHeader,
    onToggleSidebar
  } = headerProps;

  const { footerConfig, setFooterConfig, updateConfigs, addFooterActions, delegations } =
    footerProps;

  const {
    ActiveComponent,
    activeSubstep,
    instance,
    stepsState,
    componentStepConfig,
    orchestratorData,
    navigateToSubstep,
    goNext,
    goPrev
  } = stepProps;

  return (
    <div className="stepper-content flex h-full max-h-screen w-full flex-1 flex-col items-center rounded-xl bg-white">
      <div
        className={cn(
          'stepper-main-content w-full transition-all duration-300 ease-in-out',
          isEnteringFromIntro && 'entering',
          shouldAnimateHeader ? 'max-w-full' : 'max-w-[856px] xl:max-w-[968px] xxl:max-w-[968px]'
        )}>
        <Header
          headerButtonProps={headerButtonProps}
          headerOptions={headerOptions}
          headerInfoTooltip={headerInfoTooltip}
          isAdmin={isAdmin}
          progress={progressValue}
          isCompact={shouldAnimateHeader}
          isNarrowScreen={isNarrowScreen}
          onToggleSidebar={onToggleSidebar}
        />
      </div>

      <main
        ref={mainContentRef}
        className={cn(
          'stepper-main-content relative min-h-0 w-full flex-1 overflow-y-auto bg-white',
          isEnteringFromIntro && 'entering'
        )}>
        <div className="mx-auto flex h-full min-h-0 w-full max-w-[856px] flex-col xl:max-w-[968px] xxl:max-w-[968px]">
          <ActiveComponent
            setHeaderButtonProps={setHeaderButtonProps}
            setHeaderInfoTooltip={setHeaderInfoTooltip}
            isAdmin={isAdmin}
            substepCode={activeSubstep?.code}
            wizardState={{ instance, steps: stepsState }}
            setFooterConfig={setFooterConfig}
            updateConfigs={updateConfigs}
            addFooterActions={addFooterActions}
            onNext={goNext}
            onPrev={goPrev}
            defaultActions={componentStepConfig?.stepActions}
            message={componentStepConfig?.message}
            orchestratorData={orchestratorData}
            navigateToSubstep={navigateToSubstep}
            practice={practice}
          />
        </div>
      </main>

      {footerConfig?.aboveFooterContent && (
        <div className="w-full border-x-0 border-b-0 border-t border-solid border-neutral-200 bg-white">
          <div className="w-full px-4">{footerConfig.aboveFooterContent}</div>
        </div>
      )}

      <div className={cn('stepper-footer w-full', isEnteringFromIntro && 'entering')}>
        <Footer
          isAdmin={isAdmin}
          activeSubstep={activeSubstep}
          orchestratorData={orchestratorData}
          delegations={delegations}
          footerConfig={footerConfig}
          wizardState={wizardState}
          navigateToSubstep={navigateToSubstep}
          practice={practice}
        />
      </div>
    </div>
  );
};

export default StepperContent;
